import { useEffect, useState } from 'react';
import axios from 'axios';
import { MapPin } from 'lucide-react';
import { API } from '@/App';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { apiError } from './shared';

export const GeolocationSwitch = ({ user }) => {
  const superAdmin = user?.is_super_admin === true || user?.email === 'transport@dlv-express.com';
  const [settings, setSettings] = useState(null);
  const [reason, setReason] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    let active = true;
    axios.get(`${API}/internal-staff/geolocation-settings`, { withCredentials: true }).then(r => { if (active) setSettings(r.data); }).catch(() => {});
    return () => { active = false; };
  }, []);
  if (!superAdmin || !settings) return null;
  const toggle = async () => {
    setBusy(true); setError('');
    try { const { data } = await axios.put(`${API}/internal-staff/geolocation-settings`, { enabled: !settings.enabled, reason: reason.trim() }, { withCredentials: true }); setSettings(data); setReason(''); }
    catch (err) { setError(apiError(err)); } finally { setBusy(false); }
  };
  return <section className="border rounded-lg p-3 space-y-2 bg-white text-sm" data-testid="geo-settings-section">
    <p className="flex items-center gap-2 font-semibold"><MapPin className="w-4 h-4" />Localisation ponctuelle des pointages : <span data-testid="geo-settings-state" className={settings.enabled ? 'text-emerald-800' : 'text-slate-600'}>{settings.enabled ? 'activée' : 'désactivée'}</span></p>
    <p className="text-xs text-slate-600">Capture unique au début et à la fin de prestation, uniquement si activée. Conservation : {settings.retention_label} (purge quotidienne des positions, pointages conservés), seuil « imprécise » {settings.imprecise_meters} m. L’activation technique ne vaut pas validation de la nécessité du dispositif, de sa base légale ni de l’information préalable des salariés.</p>
    {settings.updated_at && <p className="text-xs text-slate-500" data-testid="geo-settings-updated">Dernier changement : {settings.updated_by_name} · {new Date(settings.updated_at).toLocaleString('fr-FR', { timeZone: 'Europe/Paris' })}</p>}
    <div className="flex flex-wrap gap-2 items-center">
      <Input className="w-full sm:w-80" placeholder="Motif du changement (facultatif)" value={reason} onChange={e => setReason(e.target.value)} data-testid="geo-settings-reason" />
      <Button variant={settings.enabled ? 'outline' : 'default'} disabled={busy} onClick={toggle} data-testid="geo-settings-toggle">{settings.enabled ? 'Désactiver' : 'Activer'}</Button>
    </div>
    {error && <p role="alert" className="text-red-700 text-xs" data-testid="geo-settings-error">{error}</p>}
  </section>;
};
